import { useCallback, useState } from "react";
import { useLocation, useSearchParams, useNavigate, Navigate } from "react-router-dom";
//
import { Button } from "@mui/material";
import ImageDataCard from "./Image/ImageDataCard";
import TextDataCard from "./Text/TextDataCard";
import { BaseNavbarPage, ErrorSnackbar, Progress } from "scandoc-react-components";
//
import { keyTranslateMap, necessaryFields, normalizeName } from "./utils";
//
import styles from "./ResultDisplay.module.css";
import submitData from "../../requests/oracle";
//
function ResultDisplay() {
	const { state } = useLocation();
	const navigate = useNavigate();
	const { hotelID, results, expectedGuest, reservationMode } = state;
	const [searchParams] = useSearchParams();
	const [outValues, setOutValues] = useState({});
	const [errorMessage, setErrorMessage] = useState(null);
	const [uploadInProgress, setUploadInProgress] = useState(false);
	//
	const expectedName = state?.expectedGuest?.Name ?? "";
	const expectedSurname = state?.expectedGuest?.Surname ?? "";
	//
	const currentName = outValues.Name ?? (results?.Data?.Name?.Read ? results.Data.Name.RecommendedValue : "");
	const currentSurname = outValues.Surname ?? (results?.Data?.Surname?.Read ? results.Data.Surname.RecommendedValue : "");
	const nameMismatch = expectedName && currentName && normalizeName(expectedName) !== normalizeName(currentName);
	const surnameMismatch = expectedSurname && currentSurname && normalizeName(expectedSurname) !== normalizeName(currentSurname);
	//
	const postData = useCallback(() => {
		const userID = searchParams.get("UserId");
		const nameID = searchParams.get("NameId");
		setUploadInProgress(true);
		
		submitData({ hotelID: hotelID, nameID: nameID, userID: userID, outValues: outValues })
			.then((isOk) => {
				if (!isOk) {
					setErrorMessage("Failed to submit!");
					return;
				}

				// go to next guest
				if (reservationMode) {
					const nextIndex = reservationMode.index + 1;
					// last guest
					if (nextIndex >= reservationMode.guests.length) {
						window.close();
						return;
					}

					const nextGuest = reservationMode.guests[nextIndex];
					const sp = new URLSearchParams(searchParams.toString());
					if (reservationMode.reservationId) sp.set("ResvNameId", reservationMode.reservationId);
					sp.set("NameId", nextGuest.guestId);

					navigate(`/${hotelID}?${sp.toString()}`, {
						replace: true,
						state: {
						reservationMode: { ...reservationMode, index: nextIndex },
						expectedGuest: {
							guestId: nextGuest.guestId,
							Name: nextGuest.Name,
							Surname: nextGuest.Surname,
						},
						},
					});
					return;
					}
					window.close();
				})
				.catch((e) => {
					console.error("submitData error:", e);
					setErrorMessage("Submit failed (see console).");
				})
				.finally(() => {
					setUploadInProgress(false);
				});
	}, [hotelID, searchParams, outValues, reservationMode, navigate]);

	const submitButtonLabel = reservationMode
		? reservationMode.index + 1 >= reservationMode.guests.length
		? "Submit & Finish"
		: "Submit & Next Guest"
		: "Submit";
	//
	return (
		<BaseNavbarPage>
			<Progress showProgress={uploadInProgress}>
				<ErrorSnackbar message={errorMessage} onRequestClose={() => setErrorMessage(null)}>
					<section className={styles.section1_data}>
						<section className={styles.section1_data__text}>
							{results["Metadata"] && results["Metadata"].length > 0 && (
								<TextDataCard
									fieldValue={results["Metadata"][0]["DocumentType"] ?? ""}
									fieldID={"DocumentType"}
									setOutValues={setOutValues}
								/>
							)}
							{Object.keys(keyTranslateMap)
								.filter((key) => (results["Data"][key] && results["Data"][key]["Read"]) || necessaryFields.includes(key))
								.map((key) => (
									<TextDataCard
										key={key}
										fieldValue={
											results["Data"][key] && results["Data"][key]["Read"] ? results["Data"][key]["RecommendedValue"] : ""
										}
										fieldID={key}
										setOutValues={setOutValues}
										expectedName={expectedName}
										expectedSurname={expectedSurname}
										nameMismatch={nameMismatch}
										surnameMismatch={surnameMismatch}
									/>
								))}
						</section>
						<section className={styles.section1_data__image}>
							{results["ImageData"]["Documents"] && (
								<ImageDataCard images={results["ImageData"]["Documents"]} title={"Document images"} setOutValues={setOutValues} />
							)}
						</section>
					</section>
					<section className={styles.section2_upload}>
						<Button variant="contained" onClick={postData} className={styles.submitButton}>
							{submitButtonLabel}
						</Button>
					</section>
				</ErrorSnackbar>
			</Progress>
		</BaseNavbarPage>
	);
}

export default ResultDisplay;
